<div class="content">
  <ion-toggle
    labelPlacement="end"
    [checked]="toggleIsOn | async"
    (ionChange)="setToggle()"
    >Try New Search</ion-toggle
  >
</div>
